import { LegalLayout } from "./LegalLayout";
import { SOCLOSE } from "../../constants/soclose";

const PRODUCT = "3DPrintForge";
const URL = "https://3dprintforge.soclose.co";

export function TermsPage() {
  return (
    <LegalLayout title="Terms of Service" updatedAt="2025-12-16">
      <p>
        These Terms of Service ("<strong>Terms</strong>") govern your use of <strong>{PRODUCT}</strong> ({URL}) and any
        related service provided by <strong>{SOCLOSE.name}</strong>, a company incorporated in Singapore under{" "}
        {SOCLOSE.uenLabel} (hereafter <em>"SoClose"</em>, <em>"we"</em>, <em>"us"</em>, <em>"our"</em>).
      </p>
      <p>By accessing or using the Service, you agree to be bound by these Terms.</p>

      <h2>1. Eligibility</h2>
      <p>
        You must be at least 18 years old (or the age of majority in your jurisdiction) and able to form a legally
        binding contract to use the Service. By using the Service you represent that you meet these requirements.
      </p>

      <h2>2. Account</h2>
      <p>
        You are responsible for keeping your credentials confidential and for any activity occurring under your account.
        Notify us immediately at <a href={`mailto:${SOCLOSE.contact.email}`}>{SOCLOSE.contact.email}</a> if you suspect
        unauthorized access.
      </p>

      <h2>3. Subscription, fees &amp; billing</h2>
      <p>
        All prices are displayed in <strong>{SOCLOSE.currency.code} ({SOCLOSE.currency.symbol})</strong> and exclude any
        applicable taxes (e.g. GST). Subscriptions renew automatically unless cancelled before the renewal date. We may
        update pricing -- you will be notified at least 30 days in advance, and changes apply at the next renewal.
      </p>

      <h2>4. Refunds</h2>
      <p>See our <a href="/refund">Refund Policy</a> for the conditions under which a refund may be granted.</p>

      <h2>5. Acceptable use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Violate any applicable Singapore or international law.</li>
        <li>Infringe intellectual property or privacy rights of third parties.</li>
        <li>Upload malware, attempt unauthorized access, or disrupt the Service.</li>
        <li>Use the Service to generate illegal content (hate, child exploitation, fraud, defamation, weapons, etc.).</li>
        <li>Resell or sublicense the Service without our prior written agreement.</li>
      </ul>
      <p>We may suspend or terminate accounts that violate these rules, without refund for the remaining period.</p>

      <h2>6. Intellectual property</h2>
      <p>
        The Service, its codebase, branding, and content (except User Content) are owned by SoClose or its licensors. We
        grant you a limited, non-exclusive, non-transferable license to use the Service for its intended purpose while
        your subscription is active.
      </p>
      <p>
        You retain all rights in the content you upload or generate (<strong>"User Content"</strong>). You grant SoClose
        a worldwide, royalty-free license strictly necessary to operate the Service (store, transmit, process, display).
        We do not claim ownership of your content and do not use it to train any model unless you explicitly opt in.
      </p>

      <h2>7. Service availability</h2>
      <p>
        We strive for high availability but provide the Service "as is" and "as available". We do not guarantee
        uninterrupted or error-free operation. Scheduled maintenance is announced when possible.
      </p>

      <h2>8. Limitation of liability</h2>
      <p>
        To the maximum extent permitted by Singapore law, our aggregate liability for any claim arising out of or
        relating to these Terms is limited to the amount you paid us in the 12 months preceding the event giving rise to
        the claim. We are not liable for indirect, incidental, special, or consequential damages.
      </p>

      <h2>9. Indemnification</h2>
      <p>
        You agree to indemnify and hold SoClose harmless from any claim arising out of your use of the Service in
        violation of these Terms or applicable law.
      </p>

      <h2>10. Termination</h2>
      <p>
        You may cancel your subscription at any time from your account settings. We may terminate or suspend access if
        you breach these Terms. Provisions that by nature survive termination (IP, liability, etc.) will continue.
      </p>

      <h2>11. Governing law &amp; jurisdiction</h2>
      <p>
        These Terms are governed by the laws of Singapore. Any dispute will be submitted to the exclusive jurisdiction of
        the courts of Singapore. The Singapore International Arbitration Centre (SIAC) may be used by mutual agreement.
      </p>

      <h2>12. Changes to Terms</h2>
      <p>
        We may update these Terms. Material changes will be communicated by email or in-app at least 30 days before they
        take effect. Continued use after the effective date constitutes acceptance.
      </p>

      <h2>13. Contact</h2>
      <address className="legal-address">
        {SOCLOSE.name}<br />
        {SOCLOSE.address.full}<br />
        Email: <a href={`mailto:${SOCLOSE.contact.email}`}>{SOCLOSE.contact.email}</a><br />
        Phone: <a href={`tel:${SOCLOSE.contact.phoneRaw}`}>{SOCLOSE.contact.phone}</a>
      </address>
    </LegalLayout>
  );
}
